export enum ReminderType{
    CONTRACT="CONTRACT",
    TEMPLATE="TEMPLATE"
}